export default __webpack_public_path__ + "static/media/auto2000.65058a44.svg";